import React from 'react';

import { ProgressButton } from '../../inputs/progress-button';
import { SecureText } from '../secure-text';
import { StoreInfoSecurelyNote } from '../store-info-securely-note';

export type SecureProgressButtonProps = React.ComponentProps<typeof ProgressButton> & {
  disableNote?: boolean;
  disableIcon?: boolean;
};

const SecureProgressButton: React.FC<SecureProgressButtonProps> = ({
  children,
  disableNote,
  disableIcon,
  ...props
}: SecureProgressButtonProps) => {
  return (
    <>
      <ProgressButton {...props}>{disableIcon ? children : <SecureText>{children}</SecureText>}</ProgressButton>

      {!disableNote && <StoreInfoSecurelyNote sx={{ mt: 2 }} />}
    </>
  );
};

export { SecureProgressButton };
